import { ActionCreatorWithoutPayload, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { SessionIdState, SessionIdVisibility } from '../../model'

export interface IdentityState {
  biometricOptOut: boolean

  biometricApplicantId?: string

  skipBiometricCheck?: boolean

  sessionId: SessionIdState
}

/**
 * Initial state for the identity reducer
 */
export const identityInitialState: IdentityState = {
  biometricOptOut: false,
  biometricApplicantId: undefined,
  skipBiometricCheck: undefined,
  sessionId: {
    visibility: SessionIdVisibility.HIDDEN,
  },
}

const slice = createSlice({
  name: 'identity',
  initialState: identityInitialState,
  reducers: {
    setBiometricOptOut(state: IdentityState, action: PayloadAction<boolean>): IdentityState {
      return {
        ...state,
        biometricOptOut: action.payload,
      }
    },

    setBiometricApplicantId(state: IdentityState, action: PayloadAction<string | undefined>): IdentityState {
      return {
        ...state,
        biometricApplicantId: action.payload,
      }
    },

    setSkipBiometricCheck(state: IdentityState, action: PayloadAction<boolean | undefined>): IdentityState {
      return {
        ...state,
        skipBiometricCheck: action.payload,
      }
    },
    setSessionIdVisibility(state: IdentityState, action: PayloadAction<SessionIdVisibility>): IdentityState {
      return {
        ...state,
        sessionId: {
          visibility: action.payload,
        },
      }
    },
    resetIdentityState(state: IdentityState): IdentityState {
      return identityInitialState
    },
  },
})

export const { setBiometricOptOut, setBiometricApplicantId, setSkipBiometricCheck, setSessionIdVisibility } = slice.actions
export const resetIdentityState = slice.actions.resetIdentityState as ActionCreatorWithoutPayload

export const identityReducer = slice.reducer
